<template>
  <div class="kb-workspace-manage">
    <AdminProgressbar :current-step="2" :tenantId="tenantId" />
    
    <div class="manage-container">
      <!-- 左侧：知识库树 -->
      <div class="kb-tree-panel">
        <div class="panel-header">
          <h3>知识库管理</h3>
          <a class="tip">(已有:{{ totalKbCount }}个/上限: {{ maxKbworkspaceCount }}个)</a>
          <el-button 
            type="plain" 
            style="margin: 10px;"
            size="small" 
            icon="el-icon-plus"
            @click="handleAddKbworkspace">
          </el-button>
        </div>
        
        <div class="tree-wrapper">
          <el-tree
            :data="treeData"
            :props="treeProps"
            node-key="id"
            :expand-on-click-node="false"
            :highlight-current="true"
            :default-expand-all="true"
            @node-click="handleNodeClick"
            ref="kbTree">
            <span class="custom-tree-node" slot-scope="{ node, data }">
              <span class="node-label">
                <i v-if="data.id === 'global_library'" class="el-icon-folder-opened" style="color: #e6a23c;"></i>
                <i v-else class="el-icon-folder-opened" style="color: #409eff;"></i>
                
                <el-tooltip 
                  :content="node.label" 
                  placement="top" 
                  :disabled="node.label.length <= 10">
                  <span class="node-name">{{ truncateText(node.label, 10) }}</span>
                </el-tooltip>
              </span>

              <!-- 全局文档库节点后的按钮 -->
              <span class="node-actions" v-if="data.id === 'global_library'">
                <!--el-tooltip content="上传文件" placement="top">
                  <i class="el-icon-upload2" @click.stop="handleGlobalUpload"></i>
                </el-tooltip -->
                      <el-tooltip content="问答对编辑器" placement="top">
                  <i class="el-icon-question" @click.stop="handleQAeditor"></i>
                </el-tooltip>
                <el-tooltip content="图文编辑" placement="top">
                  <i class="el-icon-picture" @click.stop="HandleCreateEditorDoc"></i>
                </el-tooltip>
                <el-tooltip content="目录管理" placement="top">
                  <i class="el-icon-folder-opened" @click.stop="handleGlobalDirManage"></i>
                </el-tooltip>
              </span>

              <!-- 工作区节点后的按钮 -->  
              <span class="node-actions" v-if="data.id !== 'global_library'">                    
                <el-tooltip v-if="data.parent_id == 0" content="知识库配置" placement="top">
                  <i class="el-icon-setting" @click.stop="HandleSetting(data)"></i>
                </el-tooltip>
                
                <el-tooltip v-if="data.parent_id == 0" content="分配用户" placement="top">
                  <i class="el-icon-user-solid" @click.stop="HandleGrantToUser(data)"></i>
                </el-tooltip>
                                <el-tooltip content="测试AI客服" placement="top">
                  <i class="el-icon-chat-dot-round" @click.stop="handleTestChat(data)"></i>
                </el-tooltip>   
                <el-tooltip v-if="data.parent_id == 0" content="发布" placement="top">
                  <i class="el-icon-share" @click.stop="HandleDeploy(data)"></i>
                </el-tooltip> 
                <el-tooltip v-if="data.parent_id == 0" content="客服席位管理" placement="top">
                  <i class="el-icon-service"  @click.stop="HandleSeat(data)"></i>
                </el-tooltip>                 
              </span>
            </span>
          </el-tree>
        </div>
      </div>
      
      <!-- 右侧：内容区域 - 根据节点类型切换 -->
      <div class="content-panel">
        <!-- 全局文档库内容 -->
        <div v-if="isGlobalLibrary" class="content-wrapper">
          <div class="panel-header">
            <h3>全局文档库</h3>
            <div class="header-actions">
              <el-button size="small" 
                icon="el-icon-refresh" 
                @click="refreshGlobalLibrary" 
                :loading="globalLoading"
                style="margin-left: 20px;">
                刷新
             </el-button>
         
            </div>
          </div>
          <GlobalLibrary
            ref="globalLibrary"
            :tenant-id="tenantId"
            :user-name="userInfo.username"
            @upload-success="onUploadSuccess"
            @dir-manage-success="onDirManageSuccess"
          />
        </div>
        
        <!-- 工作区文档内容 -->
        <div v-else class="content-wrapper">
          <div class="panel-header">
            <h3>{{ currentKbName || '请选择知识库' }}</h3>
            <div class="header-actions">
              <el-button size="small" icon="el-icon-refresh" @click="refreshWorkspaceDocuments" :loading="workspaceLoading">
                刷新
              </el-button>
              
        <el-badge :value="runningTaskCount" :hidden="runningTaskCount === 0" type="danger">
          <el-button 
            size="small" 
            type="primary" 
            icon="el-icon-share" 
            @click="openTaskCenter()">
            发布任务中心
          </el-button>
        </el-badge>     
            </div>
          </div>
          <WorkspaceDocuments
            ref="workspaceDocuments"
            :workspace-slug="currentKbSlug"
            :workspace-name="currentKbName"
            :tenant-id="tenantId"
            :user-name="userInfo.username"
          />
        </div>
      </div>
    </div>
    
    <!-- ==================== 对话框区域 ==================== -->
    
    <!-- 创建知识库对话框 -->
    <el-dialog :title="title" :visible.sync="open" width="450px" append-to-body>
      <el-form ref="form" :model="form" :rules="rules" label-width="200">
        <el-row :gutter="10" class="mb8">
          <el-col :span="24">
            <el-form-item label="名称" prop="name">
              <el-input v-model="form.name" placeholder="请输入知识库名称" style="width: 350px;"/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10" class="mb8">
          <el-col :span="24">
            <el-form-item label="父级知识库" prop="parent_id">
              <el-select v-model="form.parent_id" placeholder="请选择父级知识库（可选）" style="width: 350px;" clearable>
                <el-option label="无父级（顶级知识库）" :value="0"></el-option>
                <el-option
                  v-for="item in topLevelKbWorkspaces"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
                </el-option>
              </el-select>
              <p style="color: #999; font-size: small; margin-top: 5px;">选择父级知识库可建立层级关系</p>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10" class="mb8">
          <el-col :span="24">
            <el-form-item label="AI客服服务于" prop="serviceTo">
              <el-input v-model="form.serviceTo" placeholder="AI客服服务的公司或网址" style="width: 350px;"/>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitForm">确 定</el-button>
        <el-button type="plain" @click="cancel">取 消</el-button>
      </div>
    </el-dialog>
    
    <!-- 配置对话框 -->
    <el-dialog :title="title_setting" :visible.sync="open_setting" width="750px" append-to-body>
      <KbWorkspaceSetting 
        v-if="open_setting"
        :slug="currentSlug"
        :parent_id="curentParentId"
        ref="settingComponent"
        @submit-success="handleSettingSubmit"
      />
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitForm_settings">确 定</el-button>
        <el-button type="plain" @click="cancel_setting">取 消</el-button>
      </div>
    </el-dialog>
    
    <!-- 分配用户对话框 -->
    <el-dialog :title="title_grant" :visible.sync="open_grant" width="400px" append-to-body destroy-on-close>
      <el-form ref="form_grant_ref" :model="form_grant" label-width="120px">
        <el-row :gutter="10" class="mb8">
          <el-col :span="24">
            <el-form-item label="选择负责用户" prop="userName">
              <el-select v-model="form_grant.userName" placeholder="请选择" @change="handleChange_userName" style="width: 100%;">
                <el-option
                  v-for="emp in emplist" :key="emp.id"
                  :label="emp.realName"
                  :value="emp.phone">
                </el-option>
              </el-select>
              <p style="color: #999;font-size: small;margin-top: 10px;">** 不选择负责用户则取消该知识库的分配</p>
              <el-checkbox 
                v-model="form_grant.imageLibrary" 
                style="margin-top: 10px;" 
                :disabled="checkboxDisabled">
                授予管理全局图片库的权限
              </el-checkbox>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitForm_grant">确 定</el-button>
        <el-button type="plain" @click="cancel_grant">取 消</el-button>
      </div>
    </el-dialog>
    
    <!-- 发布对话框 -->
    <el-dialog :title="title_deploy" :visible.sync="open_deploy" width="750px" append-to-body>
      <KbWorkspaceDeploy 
        v-if="open_deploy"
        :slug="currentSlug"
        ref="deployComponent"
        @submit-success="handleDeploySubmit"
        @open-task-center="handleOpenTaskCenterFromDeploy"
      />
      <div slot="footer" class="dialog-footer">
                    <span 
                :title="tooltipText"
                style="display: inline-block; width: 18px; height: 16px; line-height: 16px; text-align: center; border-radius: 50%; background: #409EFF ; color: white; font-size: 12px; margin-right: 6px; cursor: help;">
                ?
              </span>
        <el-button type="primary" @click="submitForm_deploy">开始发布</el-button>
        <el-button type="plain" @click="cancel_deploy">取 消</el-button>
      </div>
    </el-dialog>
    
    <!-- 聊天窗口 -->
    <ChatWidget 
      v-if="showChat"
      :configUuid="currentChatConfigUuid"
      :tenantId="tenantId"
      :username="userInfo.username"
      @close="handleCloseChat"
    />

    <!-- 全局文档库：问答对编辑器对话框 -->
    <el-dialog title="问答对编辑器" :visible.sync="QAeditorVisible" width="80%" append-to-body>
      <QAeditor
        v-if="QAeditorVisible"
        :targetDir="currentGlobalDirName"
        :workspace_slug="defaultWorkspaceSlug"
        :workspace_name="'全局文档库'"
        :tenantId="tenantId"
        :username="userInfo.username"
        :dirId="selectedGlobalDirId"
        :dirs="dirs"
        :doctitle="title"
        @submit-success="onGlobalUploadSuccess"
        ref="globalUploadComponent" />
      <div slot="footer" class="dialog-footer">
        <!-- el-button type="primary" @click="submitGlobalUpload">确 定1</el-button>
        <el-button type="plain" @click="globalUploadVisible = false">取 消</el-button -->
      </div>
    </el-dialog>        


    <!-- 新建/编辑图文文档对话框 -->
    <el-dialog
      title="图文编辑器"
      :visible.sync="open_editor"
      width="95%"
      top="2vh"
      append-to-body
      :close-on-click-modal="false"
      custom-class="editor-dialog">
      <AnythingllmRichEditor
        v-if="open_editor"
        ref="editorComponent"
        :edit-data="currentEditDoc"
        :default-dir-id="defaultDirId"
        :userName="userName"
        :tenantId="tenantId"
        :dir-list="editorDirList"
        :workspaceSlug="defaultWorkspaceSlug"          
        @content-change="onEditorContentChange"
        @dir-change="onEditorDirChange"
      />
    </el-dialog>

    <!-- 全局文档库：目录管理对话框 -->
    <el-dialog title="目录管理" :visible.sync="globalDirManageVisible" width="600px" append-to-body>
      <AnythingllmDirManage 
        v-if="globalDirManageVisible" 
        :tenantId="tenantId" 
        @success="onDirManageSuccess" 
      />
    </el-dialog>

    <!-- ==================== 任务中心对话框 ==================== -->
  <el-dialog 
    title="发布任务中心" 
    :visible.sync="taskCenterVisible" 
    width="90%"
    append-to-body
    destroy-on-close
    :body-style="{
      'max-height': '70vh',
      'overflow-y': 'auto',
      'padding': '20px',
      'display': 'flex',
      'flex-direction': 'column'
    }"
    @close="onTaskCenterClose">
    <DeployTaskCenter 
      v-if="taskCenterVisible"
      ref="deployTaskCenter"
      :tenant-id="tenantId"
      :style="{ 'flex': 1, 'overflow-y': 'auto' }" 
      @refresh-count="loadRunningTaskCount" />
  </el-dialog>

<!-- 客服席位管理对话框 -->
<SeatManagement
  :visible.sync="seatManagementVisible"
  :workspace-slug="currentKbSlug"
  :workspace-name="currentKbName"
  :max-seat-count="maxAicsSeatCount"
  :max-workspace-count="maxKbworkspaceCount"
/>
      </div>
</template>

<script>
// 原有导入
import GlobalLibrary from '@/components/kb_workspace/GlobalLibrary.vue';
import WorkspaceDocuments from '@/components/kb_workspace/WorkspaceDocuments.vue';
import AnythingllmDirManage from '@/components/AnythingllmDirManage.vue';
import { listKbWorkspaces_by_tenantId, createKbWorkspace, listEmployees_by_tenantId, grantKbWorkspaceToUser, getUserPermission } from '@/api/aics/kbWorkspace';
import AdminProgressbar from '@/components/admin/progressbar.vue';
import KbWorkspaceDeploy from '@/components/kb_workspace/deploy.vue';
import KbWorkspaceSetting from '@/components/kb_workspace/setting.vue';
import QAeditor from "@/components/kb_workspace/QAeditor.vue";
import ChatWidget from '@/components/chat/ChatWidget.vue';
import { generateChatConfig } from '@/api/chat/chatWidget';
import AnythingllmRichEditor from "@/components/aics/AnythingllmRichEditor.vue";
import SeatManagement from '@/components/kb_workspace/SeatManagement.vue';
import { mapState } from 'vuex';
// ==================== 任务中心相关导入 ====================
import DeployTaskCenter from '@/components/kb_workspace/DeployTaskCenter.vue';
import { getRunningDeployTaskCount } from '@/api/aics/deploy';
import { listBriefDirsByTenantid} from"@/api/aics/KbDocument.js";

export default {
  name: "KbWorkspaceManage",
  components: {
    AdminProgressbar,
    KbWorkspaceSetting,
    KbWorkspaceDeploy,
    ChatWidget,
    GlobalLibrary,
    WorkspaceDocuments,   
    AnythingllmDirManage,
    QAeditor,
    AnythingllmRichEditor,
    DeployTaskCenter,
    SeatManagement
  },
  props: {
    workspaceName: {
      type: String,
      default: ""
    },
    workspaceSlug: {
      type: String,
      default: ""
    }
  },  
  data() {
    return {

    seatManagementVisible: false,
    //maxAicsSeatCount: 0,  // 从套餐获取      
      // 知识库相关
      kbWorkspaces: [],
      treeData: [],
      currentKbSlug: '',
      currentKbName: '',
      currentKbId: null,
      user_selected: false,
      isGlobalLibrary: false,
      
      // 加载状态
      docLoading: false,
      globalLoading: false,
      workspaceLoading: false,
      
      // 全局文档库相关
      // 上传文件文档
      globalUploadVisible: false,
      globalFileList: [],
      globalDirManageVisible: false,   
      dirs: [],
      // 问答对编辑器
      QAeditorVisible: false,

      
      // 图文编辑器相关
      open_editor: false,
      open_preview: false,
      editorDialogTitle: '新建图文文档',     
      editorHasContent: false,
      currentEditDoc: null,
      editorDirList: [],
      defaultDirId: null,
      
      // 对话框相关
      title: '',
      open: false,
      title_setting: '',
      open_setting: false,
      title_grant: '',
      open_grant: false,
      title_deploy: '',
      open_deploy: false,
      
      // 聊天相关
      showChat: false,
      currentChatConfigUuid: '',
      
      // 上传文档
      selectedGlobalDirId: null,
      defaultWorkspaceSlug: '',
      
      // 表单数据
      form: {
        name: '',
        serviceTo: '',
        parent_id: 0,
        masterSlug: null
      },
      form_grant: {
        userName: '',
        currentSlug: '',
        imageLibrary: false,
  
      },
             //提示文本
        tooltipText: `为避免影响AI客服的正常工作，系统将在空闲时处理您的发布请求。请不要频繁发布。
                      \r\n您可以点击页面右上角的【发布任务中心】按钮，了解发布任务的工作情况。
                      \r\n如果需要，可以在【【发布任务中心】重新发布失败的任务。`,

      currentSlug: '',
      curentParentId: 0,
      emplist: [],
      
      rules: {
        name: [{ required: true, message: "知识库名称不能为空", trigger: "blur" }],
        serviceTo: [{ required: true, message: "请填写知识库对应的AI客服为谁服务", trigger: "blur" }]
      },
      
      treeProps: {
        children: 'children',
        label: 'name'
      },
      
      userType: 'admin',
      
      // ==================== 新增：任务中心相关数据 ====================
      taskCenterVisible: false,
      runningTaskCount: 0,
      runningTaskTimer: null
    }
  },
  computed: {
    ...mapState('auth', ['tenantInfo', 'userInfo']),
    tenantId() {
      return this.tenantInfo?.tenantId || null;
    },
    maxKbworkspaceCount() {
      return this.tenantInfo?.maxKbworkspaceCount || 0;
    },
    versionName() {
      return this.tenantInfo?.versionName || '-';
    },
    totalKbCount() {
      return this.kbWorkspaces.filter(item => item.parent_id === 0).length;
    },
    topLevelKbWorkspaces() {
      return this.kbWorkspaces.filter(item => item.parent_id === 0);
    },
    currentTitle() {
      if (this.isGlobalLibrary) {
        return '全局文档库';
      }
      return this.currentKbName || '请选择知识库';
    },
    checkboxDisabled() {
      return !this.user_selected || !this.form_grant.userName;
    },
    currentGlobalDirName() {
      return this.$refs.globalLibrary?.currentDirName || '';
    },
    userName() {
      return this.userInfo?.username || null;
    },
  maxAicsSeatCount() {
      return this.tenantInfo?.maxAicsSeatCount || 10;
    }    
  },
  mounted() {
    console.info("tenantInfo", this.tenantInfo);

if(this.tenantInfo && this.tenantInfo.status && this.tenantInfo.status.trim()!=='APPROVED'){
    this.$message.error('租户状态未激活');  
    this.logout();
}      
    console.log("defaultWorkspaceSlug", this.defaultWorkspaceSlug);
    this.refreshKbTree();
    //this.loadDefaultWorkspace();
    // ==================== 新增：启动轮询任务数 ====================
    this.startPollingRunningTaskCount();
  },
  beforeDestroy() {
    // ==================== 新增：清理定时器 ====================
    if (this.runningTaskTimer) {
      clearInterval(this.runningTaskTimer);
      this.runningTaskTimer = null;
    }
  },
  watch: {
    isGlobalLibrary: {
      handler(newVal) {
        if (newVal) {
          this.$nextTick(() => {
            this.refreshGlobalLibrary();
          });
        }
      }
    },
    currentKbSlug: {
      handler(newVal, oldVal) {
        if (newVal && newVal !== oldVal) {
          this.$nextTick(() => {
            this.refreshWorkspaceDocuments();
          });
        }
      }
    }
  },
  methods: {
      handleDialogOpen() {
    this.$nextTick(() => {
        const dialogEl = this.$refs.taskCenterDialog.$el;
        if (dialogEl) {
          const dialogWrapper = dialogEl.closest('.el-dialog__wrapper');
          if (dialogWrapper) {
            const dialog = dialogWrapper.querySelector('.el-dialog');
            if (dialog) {
              dialog.style.maxHeight = '80vh';
              dialog.style.display = 'flex';
              dialog.style.flexDirection = 'column';
            }
            
            const dialogBody = dialogWrapper.querySelector('.el-dialog__body');
            if (dialogBody) {
              dialogBody.style.overflowY = 'auto';
              dialogBody.style.maxHeight = 'calc(80vh - 100px)';
            }
          }
        }
      });
  },
    
    buildTreeData(data) {
      if (!data || data.length === 0) {
        return [this.getGlobalLibraryNode()];
      }
      
      const sortedData = [...data].sort((a, b) => {
        return a.name.localeCompare(b.name, 'zh-CN');
      });
      
      const map = {};
      const roots = [];
      
      sortedData.forEach(item => {
        map[item.id] = { ...item, children: [] };
      });
      
      sortedData.forEach(item => {
        const node = map[item.id];
        if (item.parent_id === 0) {
          roots.push(node);
        } else {
          const parent = map[item.parent_id];
          if (parent) {
            parent.children.push(node);
            parent.children.sort((x, y) => x.name.localeCompare(y.name, 'zh-CN'));
          } else {
            roots.push(node);
          }
        }
      });
      
      roots.sort((a, b) => a.name.localeCompare(b.name, 'zh-CN'));
      return [this.getGlobalLibraryNode(), ...roots];
    },
    
    truncateText(text, maxLength) {
      if (!text) return '';
      if (text.length <= maxLength) return text;
      return text.substring(0, maxLength) + '...';
    },
    
    getGlobalLibraryNode() {
      return {
        id: 'global_library',
        name: '全局文档库',
        slug: null,
        parent_id: -1,
        children: [],
        isGlobalLibrary: true
      };
    },
    
    refreshKbTree() { 
      console.log("refreshKbTree", this.tenantId);
      listKbWorkspaces_by_tenantId(this.tenantId).then(res => {
        console.log("listKbWorkspaces_by_tenantId-refreshKbTree", res);
        if(res.code==200){
          this.kbWorkspaces = res.data || [];
          this.treeData = this.buildTreeData(this.kbWorkspaces);
        }
        if (!this.currentKbSlug && !this.isGlobalLibrary && this.treeData.length > 0) {
          this.handleNodeClick(this.treeData[0]);
        }
      }).catch(error => {
        console.error('获取知识库列表失败:', error);
      });
    },
    
    handleNodeClick(data) {
      if (data.id === 'global_library') {
        this.isGlobalLibrary = true;
        this.currentKbSlug = '';
        this.currentKbName = '全局文档库';
        this.currentKbId = null;
      } else {
        this.isGlobalLibrary = false;
        this.currentKbSlug = data.slug;
        this.currentKbName = data.name;
        this.currentKbId = data.id;
      }
      this.refreshDocuments();
    },
    
    handleChange_userName(value) {
      if (value === '' || value == null) {
        this.form_grant.imageLibrary = false;
        return;
      }
      this.form_grant.userName = value;
      getUserPermission(value).then(response => {
        if (response && response.code === 200 && response.data) {
          this.form_grant.imageLibrary = response.data.imageLibrary || false;
        }
      }).catch(error => {
        console.error('获取用户权限失败:', error);
      });
    },

    refreshDocuments() {
        if (this.isGlobalLibrary) {
          this.refreshGlobalLibrary();
        } else {
          this.refreshWorkspaceDocuments();
        }
    },
    
    onEditorContentChange(formData) {
      this.editorHasContent = !!(formData.htmlContent && formData.htmlContent.trim());
    },
    
    onEditorDirChange(dirId) {
      console.log('目录变更:', dirId);
    },
    
    refreshGlobalLibrary() {
      if (this.$refs.globalLibrary) {
        this.globalLoading = true;
        this.$refs.globalLibrary.refresh().finally(() => {
          this.globalLoading = false;
        });
      }
    },

    refreshWorkspaceDocuments() {
      if (this.$refs.workspaceDocuments && this.currentKbSlug) {
        this.workspaceLoading = true;
        this.$refs.workspaceDocuments.refresh().finally(() => {
          this.workspaceLoading = false;
        });
      }
    },

    handleGlobalUpload() {
      this.selectedGlobalDirId = this.$refs.globalLibrary?.selectedDirId || null;
      this.globalUploadVisible = true;
    },
    handleQAeditor(){

            console.log("开始加载目录列表...");
            listBriefDirsByTenantid(this.tenantId).then(res => {    
              console.log("目录列表API返回:", res);
              console.log("原始目录数据:", res.data.data);
              if(res.data.code == 200){
                 this.dirs = res.data.data;
                 console.log("this.dirs", this.dirs)
                 if(this.dirs && this.dirs.length>0){
                  this.dirId = this.dirs[0].id;
                 }
              }
            }).catch(error => {
              console.error("加载目录列表失败:", error);
            });      
            console.log("this.dir", this.dirId);
      this.QAeditorVisible = true;
    },

    handleBeforeUpload(file) {
      const isValid = file.size < 10 * 1024 * 1024;
      if (!isValid) {
        this.$message.error('文件大小不能超过10MB');
      }
      return isValid;
    },

    submitGlobalUpload() {
      if (this.$refs.globalUploadComponent) {
        this.$refs.globalUploadComponent.submitForm();
      }
    },

    loadDefaultWorkspace() {
      listKbWorkspaces_by_tenantId(this.tenantId).then(res => {
        const workspaces = res?.data || [];
        if (workspaces.length > 0) {
          this.defaultWorkspaceSlug = workspaces[0].slug;
        }
      });
    },
    
    onGlobalUploadSuccess() {
      this.globalUploadVisible = false;
      this.refreshGlobalLibrary();
    },

    handleUploadError(error) {
      this.$message.error('上传失败'+error);
    },

    onUploadSuccess() {
      this.refreshGlobalLibrary();
    },

    onDirManageSuccess() {
      this.refreshGlobalLibrary();
    },
    
    handleGlobalDirManage() {
      this.globalDirManageVisible = true;
    },
    
async HandleCreateEditorDoc() {
  // 确保 workspace 列表已加载
  if (this.kbWorkspaces.length === 0) {
    await this.refreshKbTree(); // 等待加载完成
  }
  
  // 确保 defaultWorkspaceSlug 有值
  if (!this.defaultWorkspaceSlug && this.kbWorkspaces.length > 0) {
    const topLevel = this.kbWorkspaces.filter(item => item.parent_id === 0);
    if (topLevel.length > 0) {
      this.defaultWorkspaceSlug = topLevel[0].slug;
    }
  }
  
  console.log('【图文编辑】defaultWorkspaceSlug:', this.defaultWorkspaceSlug);
  
  this.editorDialogTitle = '新图文文档';
  this.currentEditDoc = null;
  this.open_editor = true;
  this.editorHasContent = false;
  this.loadEditorDirectories();
},
    
    loadEditorDirectories() {
      // TODO: 调用实际API获取目录列表
      this.editorDirList = [
        { id: 1, name: '产品文档' },
        { id: 2, name: '使用指南' },
        { id: 3, name: '常见问题' }
      ];
      this.defaultDirId = 1;
    },
    
    async handleTestChat(row) {
      if (row.id === 'global_library') {
        this.$message.warning('全局文档库不支持AI客服测试');
        return;
      }
      
      try {
        this.docLoading = true;
        const response = await generateChatConfig({  
          aiSeatId: 0,
          configData: {
            title: `${row.name} - AI客服`,
            theme: 'default',
            showThemeSelector: false
          }
        }, this.tenantId, row.slug, this.userInfo.username);
        
        console.log("generateChatConfig", response)
        if (response && response.data.code === 200) {
          this.currentChatConfigUuid = response.data.data.uuid;
          this.showChat = true;
          this.$message.success('聊天窗口已打开');
        } else {
          this.$message.error(response.message || '打开聊天窗口失败');
        }
      } catch (error) {
        console.error('打开聊天窗口失败:', error);
        this.$message.error('打开聊天窗口失败');
      } finally {
        this.docLoading = false;
      }
    },
    
    handleCloseChat() {
      this.showChat = false;
      this.currentChatConfigUuid = '';
    },
    
    handleAddKbworkspace() {
      this.title = '创建知识库';
      this.open = true;
      this.form.name = this.tenantInfo?.nickname || '';
      this.form.parent_id = 0;
      this.form.serviceTo = '';
    },
    
    submitForm() {
      if (this.form.name.length > 100) {
        this.$message.error("知识库名称不能超过100个字符");
        return;
      }
      
      this.$refs["form"].validate(valid => {
        if (valid) {
          createKbWorkspace(this.tenantId, this.form).then(response => {
            
            if (response.code === 200) {
              this.$message.success('创建知识库成功');
              this.open = false;
              this.refreshKbTree();
            } else {
              this.$message.error(response.message);
            }
          }).catch(error => {
            this.$message.error(error.message);
          });
        }
      });
    },
    
    cancel() {
      this.open = false;
      this.form = { name: '', serviceTo: '', parent_id: 0, masterSlug: null };
    },
    
    HandleSetting(row) {
      if (row.id === 'global_library') {
        this.$message.warning('全局文档库没有配置项');
        return;
      }
      
      this.currentSlug = row.slug;
      this.curentParentId = row.parent_id || 0;
      this.title_setting = '知识库配置';
      this.open_setting = true;
    },
    
    submitForm_settings() {
      if (this.$refs.settingComponent) {
        this.$refs.settingComponent.submitForm();
      }
    },
    
    handleSettingSubmit(result) {
      if (result) {
        this.$message.success("设置成功");
        this.open_setting = false;
        this.refreshKbTree();
      } else {
        this.$message.error("设置失败");
      }
    },
    async logout() {
      try {
        // 调用 Vuex 中的 logout action
        await this.$store.dispatch('auth/logout')
        // 退出成功后跳转到登录页
        this.$router.push('/login')
      } catch (error) {
        console.error('退出登录失败:', error)
        // 即使退出API调用失败，也强制清除本地状态并跳转
        this.$store.commit('auth/CLEAR_AUTH')
        this.$router.push('/login')
      }
    },
        
    cancel_setting() {
      this.open_setting = false;
    },
    
    async HandleGrantToUser(row) {
      console.log("HandleGrantToUser", row);
      
      if (row.id === 'global_library') {
        this.$message.warning('全局文档库不支持分配用户');
        return;
      }

      try {
        const res = await listEmployees_by_tenantId(this.tenantId);
        this.emplist = res?.data?.rows || res?.data || [];
        this.title_grant = '为知识库【' + row.name + '】分配用户';
        
        this.form_grant = {
          currentSlug: row.slug,
          userName: row.user_name || '',
          imageLibrary: false
        };
        
        this.user_selected = !!row.user_name;
        
        if (row.user_name) {
          this.handleChange_userName(row.user_name);
        }
        
        this.open_grant = true;
      } catch (error) {
        console.error('获取员工列表失败:', error);
        this.$message.error('获取员工列表失败');
      }
    },
    
    submitForm_grant() {
      grantKbWorkspaceToUser(this.tenantId, this.form_grant).then(response => {
        if (response.code === 200) {
          this.$message.success('分配用户成功');
          this.open_grant = false;
          this.refreshKbTree();
        } else {
          this.$message.error(response.message);
        }
      }).catch(error => {
        this.$message.error(error.message);
      });
    },
    
    cancel_grant() {
      this.open_grant = false;
    },
    
    HandleDeploy(row) {
      if (row.id === 'global_library') {
        this.$message.warning('全局文档库不支持发布');
        return;
      }
      console.log("HandleDeploy", row);
      const documentCount = Number(row.document_count) || 0;
      if (documentCount <= 0) {
        this.$message.warning("知识库中没有文档，不能发布。");
        return;
      }
      
      this.currentSlug = row.slug;
      this.title_deploy = '发布AI客服中心';
      this.open_deploy = true;
    },
    
    submitForm_deploy() {
      if (this.$refs.deployComponent) {
        this.$refs.deployComponent.deploy();
      }
    },
    
    handleDeploySubmit(result) {
      if (result) {
        this.$message.success("发布知识库成功");
        this.open_deploy = false;
        this.refreshKbTree();
      } else {
        this.$message.error("发布知识库失败");
      }
    },
    
    cancel_deploy() {
      this.open_deploy = false;
    },
    
    // ==================== 新增：任务中心相关方法 ====================
    
    /**
     * 打开任务中心
     * @param {string} taskId - 可选，打开后自动选中的任务ID
     */
    openTaskCenter(taskId) {
      this.taskCenterVisible = true;
      this.$nextTick(() => {
        if (taskId && this.$refs.deployTaskCenter) {
          this.$refs.deployTaskCenter.selectTask(taskId);
        }
      });
    },
    
    /**
     * 从发布组件打开任务中心（处理 @open-task-center 事件）
     */
    handleOpenTaskCenterFromDeploy(taskId) {
      this.openTaskCenter(taskId);
    },
    
    /**
     * 任务中心关闭时的回调
     */
    onTaskCenterClose() {
      // 刷新任务数量显示
      this.loadRunningTaskCount();
    },
    
    /**
     * 加载运行中的任务数量（用于按钮小红点）
     */
    async loadRunningTaskCount() {
      console.log("loadRunningTaskCount()",this.tenantId)
      if (!this.tenantId) return;
      try {
        const res = await getRunningDeployTaskCount(this.tenantId);
        console.log("loadRunningTaskCount res", res)
          this.runningTaskCount = res.data || 0;        
      } catch (error) {
        console.error('获取运行中任务数失败:', error);
      }
    },
    
    /**
     * 启动轮询，定时刷新运行中的任务数量
     */
    startPollingRunningTaskCount() {
      // 立即加载一次
      this.loadRunningTaskCount();
      // 每30秒刷新一次
      this.runningTaskTimer = setInterval(() => {
        this.loadRunningTaskCount();
      }, 30000);
    },

 HandleSeat(row) {
    if (row.id === 'global_library') {
      this.$message.warning('全局文档库不支持客服席位管理');
      return;
    }
    this.currentKbSlug = row.slug;
    this.currentKbName = row.name;
    this.seatManagementVisible = true;
  }  
  }
}
</script>

<style scoped>
.kb-workspace-manage {
  padding: 20px;
  height: calc(100vh - 100px);
  display: flex;
  flex-direction: column;
}

.manage-container {
  display: flex;
  gap: 20px;
  flex: 1;
  min-height: 0;
  margin-top: 20px;
}

.kb-tree-panel {
  width: 320px;
  flex-shrink: 0;
  background: #fff;
  border-radius: 8px;
  border: 1px solid #e4e7ed;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.panel-header {
  padding: 15px 20px;
  border-bottom: 1px solid #e4e7ed;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.panel-header h3 {
  margin: 0;
  font-size: 16px;
  font-weight: 500;
  color: #303133;
}

.tree-wrapper {
  flex: 1;
  overflow-y: auto;
  padding: 10px 0;
}

.custom-tree-node {
  flex: 1;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 14px;
  padding-right: 8px;
}

.node-label {
  display: flex;
  align-items: center;
  gap: 6px;
}

.node-actions {
  display: none;
  gap: 8px;
}

.custom-tree-node:hover .node-actions {
  display: flex;
}

.node-actions i {
  cursor: pointer;
  color: #909399;
  font-size: 14px;
}

.node-actions i:hover {
  color: #409eff;
}

.content-panel {
  flex: 1;
  background: #fff;
  border-radius: 8px;
  border: 1px solid #e4e7ed;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.content-wrapper {
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.header-actions {
  display: flex;
  gap: 10px;
  margin-left: 30px;
}

.tip {
  font-size: small;
  margin-left: 10px;
  color: #909399;
}

.mb8 {
  margin-bottom: 8px;
}

.mb16 {
  margin-bottom: 16px;
}

/* 深色主题 */
@media (prefers-color-scheme: dark) {
  .kb-tree-panel,
  .content-panel {
    background: #1e1e1e;
    border-color: #3c3c3c;
  }
  
  .panel-header {
    border-bottom-color: #3c3c3c;
  }
  
  .panel-header h3 {
    color: #e5e5e5;
  }
}

/* 响应式 */
@media screen and (max-width: 768px) {
  .manage-container {
    flex-direction: column;
  }
  
  .kb-tree-panel {
    width: 100%;
    max-height: 300px;
  }
}

</style>